import { Button, Col, Row } from '@themesberg/react-bootstrap';
import React, { Fragment, useState, useEffect, useCallback } from 'react';
import FormInfoBodywork from '../../components/forms/inspection/form.bodywork';
import FormInfoChasis from '../../components/forms/inspection/form.chassisStructure';
import FormClaims from '../../components/forms/inspection/form.claims';
import FormFinalResult from '../../components/forms/inspection/form.finalResult';
import FormInfoFluids from '../../components/forms/inspection/form.fluids';
import FormGeneralInfo from '../../components/forms/inspection/form.infoClient';
import FormInfoVehicle from '../../components/forms/inspection/form.infoVehicle';
import FormMotorReport from '../../components/forms/inspection/form.motorReport';
import FormInfoPaint from '../../components/forms/inspection/form.paint';
import FormPropertyCard from '../../components/forms/inspection/form.propertycard';
import FormInfoTires from '../../components/forms/inspection/form.tires';
import FormVehiclePicture from '../../components/forms/inspection/form.vehiclePicture';
import FormVehiclePicturePlus from '../../components/forms/inspection/form.vehiclePicturePlus';
import FormCompBottom from '../../components/forms/inspection/vehicleComponentsForms/form.comp.bottomComp';
import FormCompCushions from '../../components/forms/inspection/vehicleComponentsForms/form.comp.cushions';
import FormCompElectric from '../../components/forms/inspection/vehicleComponentsForms/form.comp.electric';
import FormCompFluidLevels from '../../components/forms/inspection/vehicleComponentsForms/form.comp.fluidLevels';
import FormCompFluids from '../../components/forms/inspection/vehicleComponentsForms/form.comp.fluids';
import FormCompLights from '../../components/forms/inspection/vehicleComponentsForms/form.comp.ligths';
import FormCompMotorComp from '../../components/forms/inspection/vehicleComponentsForms/form.comp.motorComlement';
import { get } from '../../services/back.service';
import FormAdditionalObs from '../../components/forms/inspection/form.additionalObs';
import FormSoatPicture from '../../components/forms/inspection/form.vehiclePictureSoat';
import FormTechPicture from '../../components/forms/inspection/form.vehiclePictureTec';
import FormAddObsComp from '../../components/forms/inspection/vehicleComponentsForms/form.additionalObs';
import { useNavigate } from "react-router-dom";
import ModalMessage from "../../components/widgets/modalMessage";
import FormInfoTiresMoto from '../../components/forms/inspection/form.tiresMoto';
import FormCompFluidsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.fluids';
import FormCompFluidLevelsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.fluidLevels';
import FormCompCushionsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.cushions';
import FormCompMotorCompMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.motorComlement';
import FormCompElectricMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.electric';
import FormCompLightsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.ligths';
import FormCompBottomMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.bottomComp';
import FormVehiclePictureRecord from '../../components/forms/inspection/form.vehiclePictureRecord';
import FormAccesories from '../../components/forms/inspection/form.accesories';
import FormOwnerHistoryReport from '../../components/forms/inspection/form.propertyReport';
import FormScannerSheetReport from '../../components/forms/inspection/form.scannerReport';
import StepManager from '../../components/StepManager';
import FormScope from '../../components/collaboration/FormScope';
import PresenceBar from '../../components/collaboration/PresenceBar';
import useFinishInspection from '../../hooks/useFinishInspection';

function MobileCreateInspection({ editid }) {
  //const  = useParams();
  const [id, setId] = useState(0)
  const [vehicleclass, setVehicleclass] = useState(0)
  const [showEnd, setShowEnd] = useState(false)
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);


  const [avaibleForms, setAvaibleForms] = useState({})

  const updateService = async (id_service) => {
    const respo = await get('/peritaje/forms/' + id_service)
    if (respo.success) setAvaibleForms(respo.data);
  }

  const validStep = (step, steps) => {
    if (step === steps.length - 1) setShowEnd(true);
    if (step !== steps.length - 1) setShowEnd(false);
  }

  const validateHistoricPlate = async (id) => {
    const respo = await get('/peritaje/valid_history/' + id, {})
    if (respo.success) {
      const { data } = respo;
      if (data.count > 0) {
        setShowModal(true);
      }
    }
  }

  const goToReport = useCallback(() => navigate("/inspectionreport"), [navigate]);
  const { faltantes, finish: finishInspect, closeFaltantes } = useFinishInspection({
    inspectionId: id,
    onSuccess: goToReport,
  });

  const modelFunction = () => {
    setShowModal(false);
  }

  // Cada paso se envuelve con su scope para la edición colaborativa.
  const step = (name, scope, label, element) => ({
    name,
    component: <FormScope scope={scope} label={label}>{element}</FormScope>,
  });

  let steps = [step('General', 'principal:', 'los datos generales', <FormGeneralInfo id={id} updateId={setId} updateService={updateService} setVehicleclass={setVehicleclass} validateHistoricPlate={validateHistoricPlate} />)];

  if (avaibleForms[1]) steps.push(step('InfoChasis', 'parts:C', 'la estructura (chasis)', <FormInfoChasis id={id} vehicleclass={vehicleclass} />))
  if (avaibleForms[2]) steps.push(step('InfoBodywork', 'parts:E', 'la carrocería', <FormInfoBodywork id={id} vehicleclass={vehicleclass} />))
  if (avaibleForms[3]) steps.push(step('InfoFluids', 'fluids:F', 'los fluidos', <FormInfoFluids id={id} />))
  if (avaibleForms[17]) steps.push(step('InfoTiresMoto', 'tires:', 'las llantas (moto)', <FormInfoTiresMoto id={id} />))
  if (avaibleForms[4]) steps.push(step('InfoTires', 'tires:', 'las llantas', <FormInfoTires id={id} />))
  if (avaibleForms[5]) steps.push(step('InfoPaint', 'paint:P', 'la pintura', <FormInfoPaint id={id} />))
  if (avaibleForms[19]) steps.push(step('Accesories', 'accesories:', 'los accesorios', <FormAccesories id={id} />))
  if (avaibleForms[6]) steps.push(step('PropertyCard', 'pictures:PC', 'la cédula del vehículo', <FormPropertyCard id={id} />))
  if (avaibleForms[7]) steps.push(step('InfoVehicle', 'header:vehicle', 'la información del vehículo', <FormInfoVehicle id={id} />))
  if (avaibleForms[8]) steps.push(step('VehiclePicture', 'pictures:CI', 'las fotografías del vehículo', <FormVehiclePicture id={id} />))
  if (avaibleForms[9]) steps.push(step('CompFluids', 'components:FC', 'los fluidos de componentes', <FormCompFluids id={id} />))
  if (avaibleForms[9]) steps.push(step('CompFluidLevels', 'components:FL', 'los niveles de fluidos', <FormCompFluidLevels id={id} />))
  if (avaibleForms[9]) steps.push(step('CompMotorComp', 'components:MC', 'el complemento del motor', <FormCompMotorComp id={id} />))
  if (avaibleForms[9]) steps.push(step('CompBottom', 'components:BC', 'el montaje inferior', <FormCompBottom id={id} />))
  if (avaibleForms[9]) steps.push(step('CompCushions', 'components:CC', 'los cojines', <FormCompCushions id={id} />))
  if (avaibleForms[9]) steps.push(step('CompElectric', 'components:EC', 'el sistema eléctrico', <FormCompElectric id={id} />))
  if (avaibleForms[9]) steps.push(step('CompLights', 'components:LC', 'las luces', <FormCompLights id={id} />))
  if (avaibleForms[18]) steps.push(step('CompFluidsMoto', 'components:FC', 'los fluidos (moto)', <FormCompFluidsMoto id={id} />))
  if (avaibleForms[18]) steps.push(step('CompFluidLevelsMoto', 'components:FL', 'los niveles de fluidos (moto)', <FormCompFluidLevelsMoto id={id} />))
  if (avaibleForms[18]) steps.push(step('CompMotorCompMoto', 'components:MC', 'el complemento del motor (moto)', <FormCompMotorCompMoto id={id} />))
  if (avaibleForms[18]) steps.push(step('CompBottomMoto', 'components:BC', 'el montaje inferior (moto)', <FormCompBottomMoto id={id} />))
  if (avaibleForms[18]) steps.push(step('CompCushionsMoto', 'components:CC', 'los cojines (moto)', <FormCompCushionsMoto id={id} />))
  if (avaibleForms[18]) steps.push(step('CompElectricMoto', 'components:EC', 'el sistema eléctrico (moto)', <FormCompElectricMoto id={id} />))
  if (avaibleForms[18]) steps.push(step('CompLightsMoto', 'components:LC', 'las luces (moto)', <FormCompLightsMoto id={id} />))
  if (avaibleForms[9] || avaibleForms[18]) steps.push(step('CompObsAdditional', 'header:obsComp', 'las observaciones de componentes', <FormAddObsComp id={id} />))
  if (avaibleForms[14]) steps.push(step('ObsAdditional', 'header:obs', 'las observaciones adicionales', <FormAdditionalObs id={id} />))
  if (avaibleForms[10]) steps.push(step('Reclamos', 'claims:', 'las reclamaciones', <FormClaims id={id} />))
  if (avaibleForms[11]) steps.push(step('ReporteMotor', 'attach:MR', 'el reporte de motor', <FormMotorReport id={id} />))
  if (avaibleForms[20]) steps.push(step('OwnerHistory', 'attach:OH', 'el historial del propietario', <FormOwnerHistoryReport id={id} />))
  if (avaibleForms[21]) steps.push(step('ScannerSheets', 'attach:SS', 'las hojas escaneadas', <FormScannerSheetReport id={id} />))
  if (avaibleForms[13]) steps.push(step('ImagenesAdicionales', 'pictures:AI', 'las fotografías adicionales', <FormVehiclePicturePlus id={id} />))
  if (avaibleForms[13]) steps.push(step('ImagenesRecord', 'pictures:RI', 'las fotografías de registro', <FormVehiclePictureRecord id={id} />))
  if (avaibleForms[15]) steps.push(step('Soat', 'pictures:TM', 'la foto del SOAT', <FormSoatPicture id={id} />))
  if (avaibleForms[16]) steps.push(step('MechanicTech', 'pictures:SO', 'la foto de la ficha técnica', <FormTechPicture id={id} />))

  if (avaibleForms[12]) steps.push(step('Resultado', 'header:result', 'la calificación final', <FormFinalResult id={id} />))

  useEffect(() => { setId(editid) }, [editid]);
  return (
    <Fragment>
      {id !== 0 && (
        <div className="mb-2">
          <PresenceBar inspectionId={id} />
        </div>
      )}
      <Row>
        <Col>
          <div className="step-progress">
            <StepManager
              steps={steps}
              onStepChange={(step) => validStep(step, steps)}
            />
          </div>
        </Col>
      </Row>
      <ModalMessage
        title={'Advertencia'}
        text={`Esta placa tiene un peritaje en el historial, por favor revisar`}
        showProps={showModal}
        funcAccept={modelFunction}
        funcClose={modelFunction}
      />
      <ModalMessage
        title={'Faltantes del peritaje'}
        text={faltantes || ''}
        showProps={!!faltantes}
        funcAccept={closeFaltantes}
        funcClose={closeFaltantes}
      />
      {showEnd && (
        <div className="mt-2 d-grid gap-2">
          <Button onClick={finishInspect} size="lg">
            Finalizar Peritaje
          </Button>
        </div>
      )}
    </Fragment>)
}

export default MobileCreateInspection;
